import React from "react";

function Summer() {
  return (
    <>
      <div className="container-fluid summ pt-md-0 pb-0 my-5">
        <div className="container">
          <div className="row">
          <div className="col-lg-4">
              <img width={300} src={require("../images/tranding.png")} />
            </div>
            <div className="col-lg-8 position-relative">
              <div className="season1 position-lg-absolute position-sm-relative text-sm-center mt-sm-3">
                <p className="fs-5">New season trends!</p>
                <h1 className="py-2">Best Summer Collection</h1>
                <p className="pb-3">Sale Get up to 50% Off</p>
                <button type="button" class="btn btn-danger danger">
                  SHOP NOW
                </button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
}

export default Summer;
